var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isShowingSecondaryHeader || _vm.useSameComponent)?_c('transition',{attrs:{"name":"appear"}},[_vm._t("primary",null,{"transitionData":{ isSwitched: _vm.isShowingSecondaryHeader }})],2):_c('transition',{attrs:{"name":"appear"}},[_vm._t("secondary")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }